module.exports = __webpack_public_path__ + "static/media/laatikoiden-pesua.931dad54.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./media/photos/laatikoiden-pesua.jpg
 ** module id = 325
 ** module chunks = 0
 **/